"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExportMenu = ExportMenu;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _core = require("@focaltec-suite/core");
var _commons = require("@focaltec-suite/commons");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ListItemButton = (0, _material.styled)(_material.ListItem)(function (_ref) {
  var theme = _ref.theme;
  return {
    '&:not(.Mui-disabled)': {
      cursor: 'pointer'
    }
  };
});
function ExportMenu(_ref2) {
  var anchor = _ref2.anchor,
    onClose = _ref2.onClose,
    onDownloadTemplate = _ref2.onDownloadTemplate,
    onImport = _ref2.onImport,
    onExportSelected = _ref2.onExportSelected,
    onExportWithParams = _ref2.onExportWithParams,
    createAction = _ref2.createAction,
    getAction = _ref2.getAction,
    _ref2$items = _ref2.items,
    items = _ref2$items === void 0 ? [] : _ref2$items;
  var context = (0, _react.useContext)(_core.AppContext);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    openExport = _useState2[0],
    setOpenExport = _useState2[1];
  var allowedCreate = (0, _react.useMemo)(function () {
    return context.isGrantedAny(createAction);
  }, [context, createAction]);
  var allowedGet = (0, _react.useMemo)(function () {
    return context.isGrantedAny(getAction);
  }, [context, getAction]);
  var enabledItems = (0, _react.useMemo)(function () {
    return items.filter(function (el) {
      return !el.disabled;
    });
  }, [items]);
  var handleClickExport = (0, _react.useCallback)(function () {
    setOpenExport(function (curr) {
      return !curr;
    });
  }, []);
  var handleClickedItem = (0, _react.useCallback)(function (item) {
    return function () {
      onClose();
      item.onClick();
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_material.Menu, {
    id: "export-menu-item",
    anchorEl: anchor,
    keepMounted: true,
    onClose: onClose,
    open: true,
    TransitionComponent: _material.Fade
  }, allowedCreate && /*#__PURE__*/_react["default"].createElement(ListItemButton, {
    onClick: onDownloadTemplate,
    dense: true
  }, /*#__PURE__*/_react["default"].createElement(_material.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_commons.DownloadIcon, {
    fontSize: "small",
    color: "primary"
  })), /*#__PURE__*/_react["default"].createElement(_material.ListItemText, {
    primary: (0, _core.translate)('importable.template')
  })), allowedCreate && /*#__PURE__*/_react["default"].createElement(ListItemButton, {
    onClick: onImport,
    dense: true
  }, /*#__PURE__*/_react["default"].createElement(_material.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_commons.UploadIcon, {
    fontSize: "small",
    color: "primary"
  })), /*#__PURE__*/_react["default"].createElement(_material.ListItemText, {
    primary: (0, _core.translate)('importable.title')
  })), allowedGet && /*#__PURE__*/_react["default"].createElement(ListItemButton, {
    onClick: handleClickExport,
    dense: true
  }, /*#__PURE__*/_react["default"].createElement(_material.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_commons.ImportExportIcon, {
    fontSize: "small",
    color: "primary"
  })), /*#__PURE__*/_react["default"].createElement(_material.ListItemText, {
    primary: (0, _core.translate)('exportable.export')
  }), openExport ? /*#__PURE__*/_react["default"].createElement(_commons.ExpandLessIcon, null) : /*#__PURE__*/_react["default"].createElement(_commons.ExpandMoreIcon, null)), allowedGet && /*#__PURE__*/_react["default"].createElement(_material.Collapse, {
    "in": openExport,
    timeout: "auto",
    unmountOnExit: true
  }, /*#__PURE__*/_react["default"].createElement(_material.List, {
    component: "div"
  }, /*#__PURE__*/_react["default"].createElement(ListItemButton, {
    onClick: onExportSelected,
    dense: true
  }, /*#__PURE__*/_react["default"].createElement(_material.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_commons.CheckBoxIcon, {
    fontSize: "small",
    color: "primary"
  })), /*#__PURE__*/_react["default"].createElement(_material.ListItemText, {
    primary: (0, _core.translate)('exportable.selected')
  })), /*#__PURE__*/_react["default"].createElement(ListItemButton, {
    onClick: onExportWithParams,
    dense: true
  }, /*#__PURE__*/_react["default"].createElement(_material.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_commons.ListIcon, {
    fontSize: "small",
    color: "primary"
  })), /*#__PURE__*/_react["default"].createElement(_material.ListItemText, {
    primary: (0, _core.translate)('exportable.all')
  })))), enabledItems.length > 0 && /*#__PURE__*/_react["default"].createElement(_material.Divider, null), enabledItems.map(function (item, i) {
    return /*#__PURE__*/_react["default"].createElement(ListItemButton, {
      key: i,
      onClick: handleClickedItem(item),
      dense: true
    }, /*#__PURE__*/_react["default"].createElement(_material.ListItemIcon, null, item.icon), /*#__PURE__*/_react["default"].createElement(_material.ListItemText, {
      primary: item.label
    }));
  }));
}